import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getProductStockSkus = (params) => httpClient.get(`${ENDPOINT_API.PRODUCT_STOCKS}`, { params });
const getProductStockSkuDetail = (id) => httpClient.get(`${ENDPOINT_API.PRODUCT_STOCKS}/${id}`);
const getProductStockSkuBranches = (params, id) => httpClient.get(`${ENDPOINT_API.PRODUCT_STOCKS}/${id}/branches`, { params });
const postProductStockAPI = (params) => httpClient.post(`${ENDPOINT_API.PRODUCT_STOCKS}`, params);

export {
	getProductStockSkus,
	getProductStockSkuDetail,
	getProductStockSkuBranches,
	postProductStockAPI,
};
